export const SUPPORTED_LANGUAGES = [
  "en-GB",
  "en-US",
  "sv",
  "fr",
  "de",
  "it",
  "es",
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** Shared with boodil-client so language preference carries across apps. */
export const LANGUAGE_STORAGE_KEY = "boni_lang";

/** Map legacy `en` (and bare navigator `en`) to a regional English locale. */
export const normalizeLanguage = (
  language?: string | null,
): SupportedLanguage => {
  if (!language) return "en-US";

  if ((SUPPORTED_LANGUAGES as readonly string[]).includes(language)) {
    return language as SupportedLanguage;
  }

  const lower = language.toLowerCase();
  if (lower === "en" || lower.startsWith("en-us")) return "en-US";
  if (lower.startsWith("en-gb") || lower.startsWith("en-uk")) return "en-GB";
  if (lower.startsWith("en")) return "en-US";

  const base = lower.split("-")[0];
  if ((SUPPORTED_LANGUAGES as readonly string[]).includes(base)) {
    return base as SupportedLanguage;
  }

  return "en-US";
};
